import React from 'react';
import { Typography, Box } from '@mui/material';

function SpouseEducationInfo() {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Spouse's Level of Education
      </Typography>
      <Typography variant="body1" paragraph>
        If your spouse or common-law partner is accompanying you to Canada, their level of education can contribute points to your CRS score.
      </Typography>
      <Typography variant="body1" paragraph>
        The points are awarded based on their completed foreign or Canadian educational credentials. An Educational Credential Assessment (ECA) is required for foreign education.
      </Typography>
    </Box>
  );
}

export default SpouseEducationInfo;